import emailSpellChecker, { run } from "@zootools/email-spell-checker"
import disposableDomains from "disposable-email-domains"
import disposableWildcardDomains from "disposable-email-domains/wildcard.json"

const ALLOWED_EMAIL_DOMAINS = ["mac.com.eg"];

const EXTRA_BLOCKED_EMAIL_DOMAINS = [
    "protonmail.com",
    "protonmail.ch",
    "proton.me",
    "pm.me",
    "tousma.com",
    "biomails.com",
];

const BLOCKED_EMAIL_DOMAINS = new Set([
    ...disposableDomains,
    ...disposableWildcardDomains,
    ...EXTRA_BLOCKED_EMAIL_DOMAINS,
]);

const isBlockedEmail = (email) => {
    const at = String(email).lastIndexOf("@");
    if (at === -1) {
        return false;
    }
    const domain = String(email)
        .slice(at + 1)
        .toLowerCase()
        .trim();
    if (!domain) {
        return false;
    }

    const labels = domain.split(".");
    for (let i = 0; i < labels.length - 1; i += 1) {
        if (BLOCKED_EMAIL_DOMAINS.has(labels.slice(i).join("."))) {
            return true;
        }
    }
    return false;
};

export const isValidEmailSpelling = (email) => {
    if (isBlockedEmail(email)) {
        return false;
    }

    const spellCheckValue = run({
        email,
        domains: [...emailSpellChecker.POPULAR_DOMAINS, ...ALLOWED_EMAIL_DOMAINS],
    });

    // if suggestions are available then its a typo
    return !Boolean(spellCheckValue);
}
